import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import { isValidDate } from 'utils/utils'

import Presenter from 'components/presenters/signup/GenderAndBirthScene';
import ScenePaginationFooter from 'components/presenters/footer/ScenePaginationFooter'; 

export default function GenderAndBirthScene({
    currSceneNum,
    totalSceneNum,
    onComplete,
    onError,
    initSex,
    initBirth
}) {

    const [yearList, setYearList] = useState([]);
    const [monthList, setMonthList] = useState([]);
    const [dateList, setDateList] = useState([]);

    const [gender, setGender] = useState(null);
    const [selectYear, setSelectYear] = useState('');
    const [selectMonth, setSelectMonth] = useState('01');
    const [selectDate, setSelectDate] = useState('01');
    const [birth, setBirth] = useState(null);

    const [valid, setValid] = useState(false);

    const validateCheck = () => {
        if(selectMonth && ['02', '04', '06', '09', '11'].includes(selectMonth))
        {
            if(selectMonth === '02')
            {
                if(parseInt(selectDate) > 29)
                {
                    return false;
                }
            }
            if(parseInt(selectDate) > 30)
            {
                return false;
            }
        }
        if(!isValidDate(`${selectYear}-${selectMonth}-${selectDate}`) || !gender)
        {
            return false;
        }
        return true;
    }

    const initSelectOptions = () => {
        const currDate = new Date();
        const year = currDate.getFullYear();
        
        const years = [];
        for(let i = 1900; i < year; ++i)
        {
            const yearData = {}
            yearData['value'] = i;
            yearData['label'] = i;
            if(year - 27 === i)
            {
                setSelectYear(i);
            }
            years.push(yearData);
        }

        const months = [];
        for(let j = 1; j <= 12; ++j)
        {
            const monthData = {}
            monthData['label'] = j;
            if(j === 1)
            {
                setSelectMonth('01');
            }
            if(j < 10)
            {
                monthData['value'] = `0${j}`;
            }
            else
            {
                monthData['value'] = j;
            }
            months.push(monthData);
        }

        const dates = [];
        for(let k = 1; k <= 31; ++k)
        {
            const dateData = {};
            dateData['label'] = k;
            if(k === 1)
            {
                setSelectDate('01');
            }
            if(k < 10)
            {
                dateData['value'] = `0${k}`;
            }
            else
            {
                dateData['value'] = k;
            }
            dates.push(dateData);
        }

        setDateList(dates);
        setMonthList(months);
        setYearList(years);
    }

    const handleNextScene = () => {
        if(onComplete && validateCheck())
        {
            const data = {};
            data['sex'] = gender;
            data['birth'] = birth;
            onComplete(data);
        }
    }

    useEffect(() => {
        initSelectOptions();
    }, [])
    
    /* eslint-disable react-hooks/exhaustive-deps */ 
    useEffect(() => {
        setValid(validateCheck())
        if(validateCheck())
        {
            setBirth(`${selectYear}-${selectMonth}-${selectDate}`);
        };
    }, [gender, selectYear, selectMonth, selectDate])

    useEffect(() => {
        if(initSex || initBirth)
        {
            setGender(initSex);
            setBirth(initBirth);
        }
    }, [initSex, initBirth])
 
    return (
        <GenderAndBirthWrapper>
            <Presenter 
                gender={gender}
                setGender={setGender}
                yearList={yearList}
                monthList={monthList}
                dateList={dateList}
                selectYear={selectYear}
                setSelectYear={setSelectYear}
                selectMonth={selectMonth}
                setSelectMonth={setSelectMonth}
                selectDate={selectDate}
                setSelectDate={setSelectDate}
            />
            <ScenePaginationFooter 
                currSceneNum={currSceneNum}
                totalSceneNum={totalSceneNum}
                onComplete={handleNextScene}
                valid={valid}
            />
        </GenderAndBirthWrapper>
    )
}

const GenderAndBirthWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;
